import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const Header = styled.h2`
  color: ${colours.darkGrey};
  padding-top: 1em;

  && {
    margin-bottom: 0;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  margin: 1.5em 0;
`;

export const LinkSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

export const LinkContentDiv = styled.div`
  h3 {
    color: ${colours.darkGrey};
    font-size: ${fonts.medium};
  }

  p {
    color: ${colours.darkGrey};
    font-size: ${fonts.smallMedium};
    padding-right: 2em;
    margin-bottom: 1em;
  }
`;
